// @generated by TypeGen from LogbookApi/CruiseApi.swift - DO NOT EDIT

import type { ICruiseCreateResponse } from "../LogbookApp/CruiseApi"
import type { IAppResponse } from "../LogbookApp/Routes"
import type { ICruiseResponse, ICruisesResponse } from "../LogbookModel/Cruise"
import { IShipUserLevel } from "../LogbookModel/ShipUser"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface ICruiseUpdateRequest {
  completed?: boolean;
  data?: string;
  title?: string;
}

export interface CruiseApiEndpoints {
  "GET /api/ship/cruise": {
    params: {};
    query: {};
    request: never;
    response: ICruiseCreateResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "GET /api/ships/:shipId/cruises": {
    params: { shipId: number };
    query: {};
    request: never;
    response: ICruisesResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "GET /api/ships/:shipId/cruises/:cruiseId": {
    params: { shipId: number; cruiseId: number };
    query: {};
    request: never;
    response: ICruiseResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/cruise": {
    params: {};
    query: {};
    request: never;
    response: ICruiseCreateResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "PUT /api/ships/:shipId/cruises/:cruiseId": {
    params: { shipId: number; cruiseId: number };
    query: {};
    request: ICruiseUpdateRequest;
    response: ICruiseResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "PUT /api/ships/:shipId/cruises/:cruiseId/calculate": {
    params: { shipId: number; cruiseId: number };
    query: {};
    request: never;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
}

export const cruiseApiEndpoints = {
  "GET /api/ship/cruise": { targets: ["app"], permission: { ship: IShipUserLevel.viewCurrent } },
  "GET /api/ships/:shipId/cruises": { targets: ["app", "server"], permission: { ship: IShipUserLevel.viewAll } },
  "GET /api/ships/:shipId/cruises/:cruiseId": { targets: ["app", "server"], permission: { ship: IShipUserLevel.viewAll } },
  "POST /api/ship/cruise": { targets: ["app"], permission: { ship: IShipUserLevel.editCurrent } },
  "PUT /api/ships/:shipId/cruises/:cruiseId": { targets: ["app", "server"], permission: { ship: IShipUserLevel.editCurrent } },
  "PUT /api/ships/:shipId/cruises/:cruiseId/calculate": { targets: ["app"], permission: { ship: IShipUserLevel.editCurrent } },
} as const;

export class CruiseApi {
  constructor(private client: ApiClient) {}

  cruises = {
    canCreate: (a: ApiArgs<CruiseApiEndpoints, "GET /api/ship/cruise">) => ({
      call: (): Promise<ICruiseCreateResponse> => {
        assertTarget(this.client, "GET /api/ship/cruise", cruiseApiEndpoints["GET /api/ship/cruise"].targets);
        return this.client.call<ICruiseCreateResponse>("GET /api/ship/cruise", a);
      },
      url: (): string => this.client.url("GET /api/ship/cruise", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.viewCurrent,
    }),
    list: (a: ApiArgs<CruiseApiEndpoints, "GET /api/ships/:shipId/cruises">) => ({
      call: (): Promise<ICruisesResponse> => {
        assertTarget(this.client, "GET /api/ships/:shipId/cruises", cruiseApiEndpoints["GET /api/ships/:shipId/cruises"].targets);
        return this.client.call<ICruisesResponse>("GET /api/ships/:shipId/cruises", a);
      },
      url: (): string => this.client.url("GET /api/ships/:shipId/cruises", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.viewAll,
    }),
    get: (a: ApiArgs<CruiseApiEndpoints, "GET /api/ships/:shipId/cruises/:cruiseId">) => ({
      call: (): Promise<ICruiseResponse> => {
        assertTarget(this.client, "GET /api/ships/:shipId/cruises/:cruiseId", cruiseApiEndpoints["GET /api/ships/:shipId/cruises/:cruiseId"].targets);
        return this.client.call<ICruiseResponse>("GET /api/ships/:shipId/cruises/:cruiseId", a);
      },
      url: (): string => this.client.url("GET /api/ships/:shipId/cruises/:cruiseId", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.viewAll,
    }),
    create: (a: ApiArgs<CruiseApiEndpoints, "POST /api/ship/cruise">) => ({
      call: (): Promise<ICruiseCreateResponse> => {
        assertTarget(this.client, "POST /api/ship/cruise", cruiseApiEndpoints["POST /api/ship/cruise"].targets);
        return this.client.call<ICruiseCreateResponse>("POST /api/ship/cruise", a);
      },
      url: (): string => this.client.url("POST /api/ship/cruise", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.editCurrent,
    }),
    update: (a: ApiArgs<CruiseApiEndpoints, "PUT /api/ships/:shipId/cruises/:cruiseId">) => ({
      call: (): Promise<ICruiseResponse> => {
        assertTarget(this.client, "PUT /api/ships/:shipId/cruises/:cruiseId", cruiseApiEndpoints["PUT /api/ships/:shipId/cruises/:cruiseId"].targets);
        return this.client.call<ICruiseResponse>("PUT /api/ships/:shipId/cruises/:cruiseId", a);
      },
      url: (): string => this.client.url("PUT /api/ships/:shipId/cruises/:cruiseId", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.editCurrent,
    }),
    calculate: (a: ApiArgs<CruiseApiEndpoints, "PUT /api/ships/:shipId/cruises/:cruiseId/calculate">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "PUT /api/ships/:shipId/cruises/:cruiseId/calculate", cruiseApiEndpoints["PUT /api/ships/:shipId/cruises/:cruiseId/calculate"].targets);
        return this.client.call<IAppResponse>("PUT /api/ships/:shipId/cruises/:cruiseId/calculate", a);
      },
      url: (): string => this.client.url("PUT /api/ships/:shipId/cruises/:cruiseId/calculate", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.editCurrent,
    }),
  };
}
